import { render } from "./UnderwriterForm.vue?vue&type=template&id=0ac3b1e5&ts=true"
import script from "./UnderwriterForm.vue?vue&type=script&lang=ts"
export * from "./UnderwriterForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/UnderwriterForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ac3b1e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ac3b1e5', __exports__)) {
    api.reload('0ac3b1e5', __exports__)
  }
  
  module.hot.accept("./UnderwriterForm.vue?vue&type=template&id=0ac3b1e5&ts=true", () => {
    api.rerender('0ac3b1e5', render)
  })

}


export default __exports__